import { render, staticRenderFns } from "./ActionSendEmail.vue?vue&type=template&id=0851880b"
import script from "./ActionSendEmail.vue?vue&type=script&lang=js"
export * from "./ActionSendEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports